module.exports = __webpack_public_path__ + "img/sf-korea-photo.1899230.webp";